import React, { useEffect, useState } from "react";
import NavbarOne from "./siteTheme/NavbarOne";

import Config from "../core/config/";

export default function DownloadApp(props) {

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // Redirect to iOS App Store or iOS specific link
      window.location.href = Config.appLinks.googlePlay;
    } else if (/android/i.test(userAgent)) {
      // Redirect to Google Play Store or Android specific link
      window.location.href = Config.appLinks.appStore;
    } else {
      // Redirect for other devices or desktop
      window.location.href = Config.FRONEND_URL;
    }
  }, []);
  return (
    <div>
      <NavbarOne
        setTheme={props.setTheme}
        theme={props.theme}
      />
      <center>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mt-5 pt-5">
              <h1 className='my-5'>Download App Redirecting...</h1>
            </div>
          </div>
        </div>
      </center>
    </div>
  )
}
